<template>
  <div class="d-flex mt-2">
    <div class="side-frame-warning"></div>
    <div>
      <span style="font-size: 14px; color: #606266">
        {{ $l('table_title_order_detail') || '产品明细列表' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query')
    },
    reset() {},
  },
}
</script>
<style lang="scss" scoped>
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin: 0 !important;
}
</style>
